import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "addSKillModal",
  "data-toggle": "modal",
  ref: "skillModalRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "addSKillModal"
  }, "Add new skill"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "label fs-6" }, "Experience:", -1)
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_10 = ["data-bs-dismiss"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkillsDropdown = _resolveComponent("SkillsDropdown")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.currentSkillsIDs)
              ? (_openBlock(), _createBlock(_component_SkillsDropdown, {
                  key: _ctx.key,
                  error: _ctx.error,
                  onSelectSkill: _cache[0] || (_cache[0] = 
                id => {
                  _ctx.skillID = id;
                }
              ),
                  onClearError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.error = false)),
                  currentSkills: _ctx.currentSkillsIDs
                }, null, 8, ["error", "currentSkills"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createVNode(_component_el_input, {
              type: "textarea",
              placeholder: "Please input experience",
              modelValue: _ctx.textarea,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textarea) = $event)),
              rows: "3",
              maxlength: "100",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateAndSave && _ctx.validateAndSave(...args))),
            type: "button",
            "data-bs-dismiss": this.skillID != '' ? 'modal' : '',
            class: "btn btn-success"
          }, " Save ", 8, _hoisted_10)
        ])
      ])
    ])
  ], 512))
}